module.exports = __webpack_public_path__ + "static/media/ic_image_upload.6fb97b19.svg";